import CartTotal from "components/Cart/CartTotal"
import ProductTable from "components/Product/ProductTable"
import { observer } from "mobx-react"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Button, Message } from "semantic-ui-react"
import shop from "shop/shop"
import track from "shop/track"
import cmsStore from "stores/cmsStore.js"
import "style/CheckoutPage.scss"
import HeaderCheckout from "pages/checkout/HeaderCheckout"
import queryString from "qs"
import CartExport from "components/Cart/CartExport"
import CostCentres from "../../../../components/CostCentres/CostCentres";

@observer
export default class CheckoutPage extends Component {
  
  state = {
    products: getProducts()
  }
  
  componentDidMount() {
    shop.cart.hooks.changed.add( this.updateCart )
    track.checkout( { step: 1, products: shop.cart.products } )
  }
  
  handleChange = ( { product } ) => {
    shop.cart.add( product )
  }
  
  updateCart = () => {
    let products = getProducts()
    this.setState( { products } )
    this.forceUpdate()
  }
  
  componentWillUnmount() {
    shop.cart.hooks.changed.remove( this.updateCart )
  }
  
  render() {
    const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
    let { products } = this.state
    const { loading } = shop.cart
    const { checkoutType } = this.props.match.params
    const isRequest = !!checkoutType
    console.log("shop.config:" , shop.session.value)

    const languageCheck = shop.session.value ? shop.session.value : "de"
    // MINDERMENGENZUSCHLAG UNTER 50 EUR
    const MIN_ORDER = shop.config.MIN_ORDER_PENALTY_VALUE
    
    const showPenaltyNotice = shop.cart.sum < MIN_ORDER
    console.log('SESSION CHECK: ',shop.session);
    return (
      <div className=" ">
        <HeaderCheckout activeStep={0} isRequest={isRequest} referer={referer}/>
        
        <section className="container">
          <ProductTable cart={shop.cart} onChange={this.handleChange} products={products}/>
          {shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <div className="cf pt3 pb3">
            <div className="fr">
              <CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
            </div>
          </div>}
          {languageCheck != "de" && shop.config.MIN_ORDER_PENALTY_VALUE && shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <Message>
            <div>{translate( "MIN_ORDER_VALUE_NOTICE", { value: `${shop.config.MIN_ORDER_PENALTY_VALUE}` } )}</div>
          </Message>}
          
          {cmsStore.pluginData.export && <div className="pv3">
            <CartExport/>
          </div>}
        </section>
        
        <section className="pa2 mb4 ">
          <div className="container">
            <div className="flex flex-row justify-end">
              
              <Link className={"mr3"} to={referer}>
                <Button>
                  <i className="icon-angle-left"/>
                  {translate( "Zurück" )}
                </Button>
              </Link>
              
              {!shop.session.handId && shop.session && shop.session.shopuser && 
              !shop.session.shopuser.guest && <Link to={{
                pathname: `${this.props.location.pathname}delivery`,
                search  : this.props.location.search
              }}>
                <Button
                  loading={loading}
                  primary>
                  {translate( "Jetzt bestellen" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}

              {!shop.session.handId && shop.session && shop.session.shopuser && shop.session.shopuser.guest && shop.session.shopuser.guest == true && <Link to={{
                pathname: `${this.props.location.pathname}customer`,
                search  : this.props.location.search
              }}>
                <Button
                  loading={loading}
                  primary>
                  {translate( "Weiter" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}
              
              {shop.session.handId && <Link to={`${this.props.location.pathname}discount`}>
                <Button
                  loading={loading}
                  primary>
                  {translate( "Weiter" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}
            </div>
          
          </div>
        </section>
      
      
      </div>
    )
  }
}

const getProducts = () => shop.cart.map( ( product ) => product )



// WEBPACK FOOTER //
// ./src/theme/braunco/pages/checkout/CheckoutPage.js